import { itemServices } from 'src/services/reservation/item/item.service'
import { customAwait } from 'src/components/pages/sales/reservation/helper/customAwait'
import { GUARANTEED } from '../logic/common/state'
type Refresh = () => void

interface RefreshHotelItemReservationParams {
  hashItemReserve: string
  nameReserve: string
  refresh: Refresh
  notify: any
  setLoadingRefreshHotel: React.Dispatch<React.SetStateAction<boolean>>
  setNameReserve: React.Dispatch<React.SetStateAction<string>>
  setHashItemReserve: React.Dispatch<React.SetStateAction<string>>
  setConfirmRefreshHotel: React.Dispatch<React.SetStateAction<boolean>> | undefined
  setOpenRefreshHotelModal: React.Dispatch<React.SetStateAction<boolean>> | undefined
}

export const refreshHotelItemReservation = async ({
  hashItemReserve,
  nameReserve,
  refresh,
  notify,
  setLoadingRefreshHotel,
  setNameReserve,
  setHashItemReserve,
  setConfirmRefreshHotel,
  setOpenRefreshHotelModal,
}: RefreshHotelItemReservationParams): Promise<void> => {
  try {
    setLoadingRefreshHotel(true)
    setOpenRefreshHotelModal && setOpenRefreshHotelModal(false)
    const status = await itemServices.refresh_hotel_detail(hashItemReserve)
    if (status === 200) {
      notify('ra.notification.updated_success_masculine', {
        type: 'success',
        messageArgs: { element: nameReserve },
      })
      setNameReserve('')
      setHashItemReserve('')
      setConfirmRefreshHotel && setConfirmRefreshHotel(false)
      return
    }
    setNameReserve('')
    setHashItemReserve('')
    setConfirmRefreshHotel && setConfirmRefreshHotel(false)
    notify('ra.notification.updated_error_masculine', {
      type: 'error',
      messageArgs: { element: nameReserve },
    })
  } catch (error) {
    notify('ra.notification.updated_error_masculine', {
      type: 'error',
      messageArgs: { element: nameReserve },
    })
    setNameReserve('')
    setHashItemReserve('')
    setConfirmRefreshHotel && setConfirmRefreshHotel(false)
    setOpenRefreshHotelModal && setOpenRefreshHotelModal(false)
  } finally {
    customAwait([refresh, () => setLoadingRefreshHotel(false)])
  }
}
